import { render, staticRenderFns } from "./ALCTR.vue?vue&type=template&id=28096ac6&"
import script from "./ALCTR.vue?vue&type=script&lang=js&"
export * from "./ALCTR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports